import { render, staticRenderFns } from "./KitIdAlert.vue?vue&type=template&id=cbc905ba&scoped=true&"
import script from "./KitIdAlert.vue?vue&type=script&lang=js&"
export * from "./KitIdAlert.vue?vue&type=script&lang=js&"
import style0 from "./KitIdAlert.vue?vue&type=style&index=0&id=cbc905ba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbc905ba",
  null
  
)

export default component.exports